import React, { Component } from 'react';
import GridRow from './GridRow';
import GridGroupRow from './GridGroupRow';
import _find from 'lodash/find';
import _some from 'lodash/some';

const getBodyGroups = (rows, gridConfig) => {
  const { groupField } = gridConfig;
  return rows.reduce((results, currentItem) => {
    let group = _find(results, (groupArr) => _some(groupArr, (item) => item[groupField] === currentItem[groupField]));
    if (group) {
      group.push(currentItem);
    } else {
      results.push([ currentItem ]);
    }
    return results;
  }, []);
};

class GroupBody extends Component {
  constructor(props) {
    super(props);
    this.state = { bodyAdditionClasses: '' };
  }

  onChangeBodyClass = (classString) => {
    this.setState({ bodyAdditionClasses: classString });
  };

  render() {
    return (
      <tbody className={`grid-body-group ${this.state.bodyAdditionClasses}`}>
        {this.props.group.map((row, index) => {
          return (
            <GridGroupRow
              row={row}
              onChangeBodyClass={this.onChangeBodyClass}
              rowspan={this.props.group.length}
              rowWithGroupCell={index === 0}
              key={`body-group-key-${index}`}
              {...this.props}
            />
          );
        })}
      </tbody>
    );
  }
}

const mapGroupBodyTable = (props) => {
  const bodyGroups = getBodyGroups(props.rows, props.gridConfig);
  return bodyGroups.map((group, index) => {
    return <GroupBody group={group} {...props} key={`body-group-key-${index}`} />;
  });
};

const GridBody = (props) => {
  if (props.gridConfig && props.gridConfig.isGroupView) {
    return <table className="grid-content">{mapGroupBodyTable(props)}</table>;
  }
  return (
    <table className="grid-content">
      <tbody>{(props.rows || []).map((row, index) => <GridRow columns={props.columns} row={row} key={index} />)}</tbody>
    </table>
  );
};

export default GridBody;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridBody.jsx